var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgTz = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#338af3",
  d: "M0 85.337h512v341.326H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#6da544",
  d: "M0 426.663V85.337h512"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffda44",
  d: "M512 152.222V85.337H411.67L0 359.778v66.885h100.33z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M512 85.337v40.125L60.193 426.663H0v-40.125L451.807 85.337z"
})));

export default SvgTz;